import { render } from "./succeed.vue?vue&type=template&id=6f77e208&scoped=true"
import script from "./succeed.vue?vue&type=script&lang=js"
export * from "./succeed.vue?vue&type=script&lang=js"

import "./succeed.vue?vue&type=style&index=0&id=6f77e208&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Code\\vue\\xypt-admin-wx\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f77e208"]])

export default __exports__